import type { TableColumnConfig } from '@ipfabric/utils';
import { type FC, memo } from 'react';
import {
  TABLE_SETTINGS_COLUMN_DRAG_TYPE,
  TableSettingsColumn,
  type TableSettingsColumnDragItem,
} from './TableSettingsColumn';

interface Props {
  draggedColumn: TableColumnConfig['key'] | null;
  item: TableSettingsColumnDragItem;
}

const BareTableSettingsColumnPreview: FC<Props> = (props) => {
  if (
    props.draggedColumn === null ||
    !props.item ||
    props.draggedColumn !== props.item.column.key ||
    props.item.type !== TABLE_SETTINGS_COLUMN_DRAG_TYPE
  ) {
    return null;
  }

  return (
    <div className='w-96 -ml-4 pointer-events-none'>
      <div className='px-4 bg-white flex flex-col shadow-xl'>
        <TableSettingsColumn
          columnIndex={props.item.index}
          columnIsDragged
          column={props.item.column}
          onColumnIsDraggedChange={() => {}}
        />
      </div>
    </div>
  );
};

export const TableSettingsColumnPreview = memo(BareTableSettingsColumnPreview);
